export const DEFAULT_STATES = {
  fetchedPropertyData: {},
  expandedRows: {},
  sortConfig: { key: 'profit', direction: 'desc' },
  rowsPerPage: 10,
  mapSidebarOpen: false,
  selectedAddress: '',
  summaryModalOpen: false,
  selectedProperty: null,
  summarizing: false,
  propertyDetailsModalOpen: false,
  selectedPropertyForDetails: null,
  zillowModalOpen: false,
  zillowUrl: '',
  zillowPropertyAddress: '',
  displayedListings: [],
  activePointIndex: null,
  isAutoRefreshing: false,
  columnWidths: {
    sale_date: 150,
    property: 300,
    upset_value: 150,
    downpayment: 200,
    zillow_estimate: 200,
    profit: 150
  },
  valuationQueue: [],
  estimatedTimeRemaining: null,
  rateLimitRetries: {},
  requestQueue: [],
  isProcessingQueue: false,
  failedRequests: new Set()
};